{
  document.addEventListener("DOMContentLoaded", function () {
    const videoBoxes = document.querySelectorAll('.mainVideoBox');

    videoBoxes.forEach(box => {
      const video = box.querySelector('video');
      const playBtn = box.querySelector('.mainplayBtnVideo');

      const togglePlay = () => {
        if (video.paused) {
          video.play();
          box.classList.add('is-playing');
        } else {
          video.pause();
          box.classList.remove('is-playing');
        }
      };

      box.addEventListener('click', togglePlay);

      video.addEventListener('ended', () => {
        box.classList.remove('is-playing');
        video.currentTime = 0;
      });
    });
  });
}

{
  document.addEventListener("DOMContentLoaded", function () {
    function faqsAccordion() {
      var accordionSections = document.querySelectorAll(".accordion-item");

      if (accordionSections.length > 0) {
        var firstAccordionItemHeader = accordionSections[0].querySelector(
          ".accordion-item-header"
        );
        var firstAccordionItemBody =
          firstAccordionItemHeader.nextElementSibling;

        if (firstAccordionItemBody) {
          firstAccordionItemHeader.classList.add("active");
          firstAccordionItemBody.style.maxHeight =
            firstAccordionItemBody.scrollHeight + "px";
        }

        for (let i = 1; i < accordionSections.length; i++) {
          var otherHeader = accordionSections[i].querySelector(
            ".accordion-item-header"
          );
          var otherBody = otherHeader.nextElementSibling;

          if (otherBody) {
            otherHeader.classList.remove("active");
            otherBody.style.maxHeight = "0";
          }
        }
      }

      accordionSections.forEach((section) => {
        var accordionItemHeaders = section.querySelector(
          ".accordion-item-header"
        );
        var accordionItemBody = section.querySelector(".accordion-item-body");

        accordionItemHeaders.addEventListener("click", function () {
          var currentlyActiveHeader = document.querySelector(
            ".accordion-item-header.active"
          );
          var currentlyActiveBody = currentlyActiveHeader
            ? currentlyActiveHeader.nextElementSibling
            : null;

          if (currentlyActiveHeader && currentlyActiveBody) {
            currentlyActiveHeader.classList.remove("active");
            currentlyActiveBody.style.maxHeight = 0;
          }

          if (accordionItemHeaders !== currentlyActiveHeader) {
            accordionItemHeaders.classList.add("active");
            accordionItemBody.style.maxHeight =
              accordionItemBody.scrollHeight + "px";
          } else {
            accordionItemHeaders.classList.remove("active");
            accordionItemBody.style.maxHeight = 0;
          }
        });
      });
    }

    faqsAccordion();
  });
}

{

    const btns = document.querySelectorAll('.tab-btn');
  const panels = document.querySelectorAll('.tab-panel');

  btns.forEach((btn, index) => {
    btn.addEventListener('click', () => {
      btns.forEach(b => { b.classList.remove('active'); b.setAttribute('aria-selected', 'false'); });
      panels.forEach(p => p.classList.remove('active'));
      btn.classList.add('active');
      btn.setAttribute('aria-selected', 'true');
      panels[index].classList.add('active');
    });
  });
}

// POPUP SCRIPT - START ***
{
  document.addEventListener("DOMContentLoaded", function () {

    if (window.innerWidth <= 1024) return;

    const modal = document.querySelector(".modal-prnt");
    const modalNumber = document.querySelector(".modal-number span");
    const qr = document.querySelector(".modal-num-qrcd img");
    const qrLabel = document.querySelector(".modal-num-qrcd span");

    document.querySelectorAll('a[href^="tel:"]').forEach(function (link) {

      link.addEventListener("click", function (e) {
        e.preventDefault();

        // Modal Open
        modal.classList.add("ActiveModal");

        // Show Number
        modalNumber.textContent = this.textContent.trim();

        // Read phone from href
        const phone = this.getAttribute("href").replace("tel:", "");

        // Remove all non-numeric characters
        const cleanPhone = phone.replace(/\D/g, "");

     switch (cleanPhone) {

  case "4808870244":
  case "14808870244":
    qr.src = "https://cdn.shopify.com/s/files/1/0734/7168/8900/files/480-887-0244.png?v=1781525904";
    if (qrLabel) qrLabel.innerHTML = "Contact Us";
    break;

  case "4806855911":
  case "14806855911":
    qr.src = "https://cdn.shopify.com/s/files/1/0734/7168/8900/files/480-685-5911.png?v=1781526008";
    if (qrLabel) qrLabel.innerHTML = "Text Us";
    break;

  case "4808476868":
  case "14808476868":
    qr.src = "https://cdn.shopify.com/s/files/1/0734/7168/8900/files/480_847-6868.png?v=1783012659";
    if (qrLabel) qrLabel.innerHTML = "Contact Us";
    break;

  default:
    qr.removeAttribute("src");
    if (qrLabel) qrLabel.innerHTML = "Contact Us";
}

      });

    });

    document.querySelectorAll(".overlay-number, .modal-close").forEach(function (el) {
      el.addEventListener("click", function () {
        modal.classList.remove("ActiveModal");
      });
    });

  });
}
// POPUP SCRIPT - END ***

{
  document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('a[href^="tel:"]').forEach(function (link) {

    const phone = link.getAttribute("href").replace("tel:", "").replace(/\D/g, "");

    if (phone === "4806855911" || phone === "14806855911") {
      link.href = "sms:+14806855911";
      link.title = "sms:+14806855911";
    }

  });
});
}

{
document.addEventListener("DOMContentLoaded", function () {
  const items = document.querySelectorAll(".popup__Serv_cate");

  items.forEach(function (item) {
    const icon = item.querySelector(".popup_serv_icon");

    if (!icon) return;

    icon.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const isActive = item.classList.contains("active");

      // Sirf ek popup open rahe
      items.forEach(function (el) {
        el.classList.remove("active");
      });

      if (!isActive) {
        item.classList.add("active");
      }
    });
  });
});
}

// {
//   document.querySelectorAll('.template-all-blogs .blog-post-item').forEach(item => {
//   if (item.querySelector('.BLOGS__BOX.Providers')) {
//     item.remove();
//   }
// });
// }